import React, { useState, useEffect, useMemo } from "react"
import { withRouter } from "react-router"
import { get } from "lodash"
import { SummaryTemplate } from "components/templates/top/summary"
import { worldRankingState, worldRankingApi } from "components/actions/ranking"
import { indicatorListApi } from "components/actions/indicatorList"
import { statisticsApiCall } from "components/actions/divisionStatistics"
import { calenderApi } from "components/actions/getProfitAnnouncementCalender"
import {
  miniChartApi,
  indexApi,
} from "components/actions/priceList/worldSummary"
import { Sort } from "utils/sort"
import { Config } from "config/config"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

//トップ＞ワールドサマリ:最上位コンポーネント
export const Summary = withRouter(({ history, location }) => {
  const [chartData, updateChart] = useState([])
  const [indexData, changeIndex] = useState([])
  const [indicatorListData, changeIndicatorList] = useState([])
  const [statisticsData, updateStatistics] = useState([])
  const [calenderData, setCalenderData] = useState({})
  const [rankingData, changeRanking] = useState<worldRankingState>({
    exchangeTypeNum: 0,
    priceIncreaseList: [],
    priceReductionList: [],
    volumeList: [],
    priceIncreaseTime: "",
    priceReductionTime: "",
    volumeTime: "",
  })
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )
  const loadResistId = useMemo(() => uuid(), [])

  const updateFuncList = {
    chart: updateChart,
    index: changeIndex,
    statistics: updateStatistics,
    ranking: changeRanking,
    indicator: changeIndicatorList,
    calender: setCalenderData,
  }

  const requestApi = () => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    Promise.all([
      miniChartApi({ updateChart: updateChart }),
      indexApi({
        indexTypeNum: 0,
        marketScopeNum: 0,
        apiParam: "Top.Summary.Benchmark",
        changeIndex: changeIndex,
      }),
      statisticsApiCall({
        updateStatistics: updateStatistics,
        division: "0111,0114,0124",
      }),
      worldRankingApi({
        exchangeTypeNum: 0,
        priceIncrease: Sort.WorldSummaryRankingExchange[0].priceIncrease,
        priceReduction: Sort.WorldSummaryRankingExchange[0].priceReduction,
        volume: Sort.WorldSummaryRankingExchange[0].volume,
        changeRanking: changeRanking,
      }),
      indicatorListApi({
        displayPeriodNum: 0,
        indicatorTypeNum: 3,
        apiParam: "Top.Summary.All.Today",
        changeIndicatorList: changeIndicatorList,
      }),
      calenderApi({
        setData: setCalenderData,
        today: true,
      }),
    ]).then(() => {
      store.dispatch(pageLoadRegist(loadResistId, false))
    })
  }
  useEffect(() => {
    requestApi()
  }, [])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) requestApi()
  }, [isPageLoading])

  //ランキングポーリング(1回/15sec)
  useEffect(() => {
    let polling = setInterval(() => {
      const exchangeTypeNum = get(rankingData, "exchangeTypeNum")
      const rankingType = Sort.WorldSummaryRankingExchange[exchangeTypeNum]
      worldRankingApi({
        exchangeTypeNum: exchangeTypeNum,
        priceIncrease: rankingType.priceIncrease,
        priceReduction: rankingType.priceReduction,
        volume: rankingType.volume,
        changeRanking: changeRanking,
      })
    }, Config.api.rankingPollingInterval)
    return () => {
      clearInterval(polling)
    }
  }, [rankingData])

  return (
    <SummaryTemplate
      chartData={chartData}
      indexData={indexData}
      changeIndex={changeIndex}
      indicatorListData={indicatorListData}
      changeIndicatorList={changeIndicatorList}
      statisticsData={statisticsData}
      rankingData={rankingData}
      changeRanking={changeRanking}
      callRankingApi={worldRankingApi}
      calenderData={calenderData}
      history={history}
      topFlag={true}
      updateFuncList={updateFuncList}
    />
  )
})
